module.exports = __webpack_public_path__ + "img/onboarding-decoration-4.7517d338.svg";